<template>
  <card class="card" title=""><br />
    <div class="row">
      <div class="col-md-4">
        <label>Estación</label>
        <div class="d-flex" :style="statusData">
          <vSelect
            :options="stations"
            placeholder="Selecciona..."
            v-model="stationId"
            style="width: 100%"
            v-on:input="getPackages()"
          />
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-end" v-if="summary">
        <p class="mb-2">
          <strong>{{ summary.totalElements }}</strong> paquetes ·
          <strong>{{ summary.totalFiles.toLocaleString() }}</strong> archivos ·
          {{ formatBytes(summary.totalOriginalBytes) }} originales ·
          {{ formatBytes(summary.totalZipBytes) }} comprimidos
        </p>
      </div>
    </div><br />

    <div class="table-responsive">
      <div class="col-md-12">
        <div :hidden="status">
          <div class="alert alert-info" role="alert">
            <center>Cargando datos, por favor espere ...</center>
          </div>
        </div>

        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th>Tipo</th>
              <th>Periodo</th>
              <th class="text-right">Archivos</th>
              <th class="text-right">Original</th>
              <th class="text-right">Tamaño zip</th>
              <th>Estado</th>
              <th>Destino</th>
              <th>Verificado</th>
              <th class="text-center">Zip</th>
              <th class="text-center">Inventario</th>
              <th class="text-center">Ambos</th>
            </tr>
          </thead>
          <tbody v-if="content.length > 0">
            <tr v-for="p in content" :key="p.id">
              <td>{{ p.source }}</td>
              <td>{{ p.period }}</td>
              <td class="text-right">{{ p.fileCount.toLocaleString() }}</td>
              <td class="text-right">{{ formatBytes(p.originalBytes) }}</td>
              <td class="text-right">{{ formatBytes(p.zipBytes) }}</td>
              <td><span :class="'badge ' + statusBadge(p.status)">{{ statusLabel(p.status) }}</span></td>
              <td>{{ dispositionLabel(p.disposition) }}</td>
              <td>{{ p.verifiedAt ? p.verifiedAt.substring(0, 10) : '—' }}</td>
              <td v-for="d in DOWNLOADS" :key="d.what" class="text-center">
                <i v-if="downloadable(p)" class="material-icons"
                  :style="{ cursor: 'pointer', color: 'green' }"
                  @click="download(p.id, d.what)" :title="d.title">
                  {{ d.icon }}
                </i>
                <span v-else class="text-muted" :title="notDownloadableReason(p)">—</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11" style="background-color:#eee;">
                <center>{{ stationId ? 'Esta estación no tiene histórico' : 'Selecciona una estación' }}</center>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </card>
</template>

<script>
import archivePackagesService from '../../services/archivePackagesService';
import state from "../../store/state";
import vSelect from "vue-select";
import store from "../../store";
import Swal from 'sweetalert2';

const STATUS = {
  BUILT: ['Generado', 'badge-secondary'],
  VERIFIED: ['Verificado', 'badge-success'],
  ORIGINALS_DELETED: ['Originales eliminados', 'badge-info'],
  PURGED: ['Entregado y depurado', 'badge-dark']
};
const DISPOSITION = {
  PENDING: 'Pendiente',
  PAID_ARCHIVE: 'Archivo pagado',
  PENDRIVE: 'Memoria USB',
  NONE: 'Sin resguardo'
};

export default {
  components: { vSelect },
  name: "archivePackages",
  data() {
    return {
      DOWNLOADS: [
        { what: 'zip', icon: 'archive', title: 'Descargar el paquete (zip con los archivos originales)' },
        { what: 'manifest', icon: 'description', title: 'Descargar el inventario (lista CSV de los archivos que contiene el zip)' },
        { what: 'both', icon: 'download', title: 'Descargar zip e inventario' },
      ],
      stations: [],
      stationId: null,
      content: [],
      summary: null,
      statusData: {},
      status: true
    };
  },
  methods: {
    formatBytes(b) {
      if (b === null || b === undefined) return '—';
      const u = ['B', 'KB', 'MB', 'GB', 'TB'];
      let i = 0;
      let v = b;
      while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
      return v.toFixed(i === 0 ? 0 : 1) + ' ' + u[i];
    },
    statusLabel(s) { return (STATUS[s] || [s])[0]; },
    statusBadge(s) { return (STATUS[s] || [null, 'badge-light'])[1]; },
    dispositionLabel(d) { return DISPOSITION[d] || d; },
    downloadable(p) {
      return (p.status === 'VERIFIED' || p.status === 'ORIGINALS_DELETED') && p.disposition !== 'PAID_ARCHIVE';
    },
    notDownloadableReason(p) {
      return p.disposition === 'PAID_ARCHIVE' ? 'En almacenamiento frío: requiere restauración' : 'Paquete aún no verificado';
    },

    async getPackages() {
      if (!this.stationId) {
        this.content = [];
        this.summary = null;
        return;
      }
      this.statusData = { 'pointer-events': 'none', 'opacity': '0.4' };
      this.status = false;
      const resp = await archivePackagesService.getPackages(this.stationId.station);
      this.statusData = {};
      this.status = true;
      if (!resp || !resp.data || resp.data.error || !resp.data.data) {
        this.content = [];
        this.summary = null;
        Swal.fire({ title: '¡Aviso!', text: 'No se pudo consultar el histórico', icon: 'warning', timer: 4000 });
        return;
      }
      this.content = resp.data.data.content;
      this.summary = resp.data.data;
    },

    // A direct link per file: the browser saves it (S3 serves application/zip / application/gzip) and stays on
    // the page. window.open() after an await is treated as a pop-up, so the second file used to be blocked.
    saveUrl(url) {
      const a = document.createElement('a');
      a.href = url;
      a.rel = 'noreferrer';
      a.download = '';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    async download(id, what) {
      const resp = await archivePackagesService.getDownload(id);
      if (!resp || !resp.data || resp.data.error) {
        const msg = resp && resp.data ? resp.data.message : '';
        Swal.fire({
          title: '¡Aviso!',
          text: msg === 'restore required' ? 'El paquete está en almacenamiento frío y requiere restauración'
            : msg === 'package not verified' ? 'El paquete aún no está verificado'
              : 'No se encontró el paquete, consulte a su administrador',
          icon: 'warning', timer: 4000
        });
        return;
      }
      const urls = resp.data.data;
      if (what === 'zip' || what === 'both') this.saveUrl(urls.zip);
      if (what === 'manifest') this.saveUrl(urls.manifest);
      // 'both': the browser may ask once to allow multiple downloads from this site.
      if (what === 'both') setTimeout(() => this.saveUrl(urls.manifest), 1200);
    }
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted() {
    if (localStorage.getItem('stationsJSON') && JSON.parse(localStorage.getItem('stationsJSON')).length > 0) {
      this.stations = JSON.parse(localStorage.getItem('stationsJSON'));
    } else {
      setTimeout(() => { this.stations = state.stations.select }, 2000);
    }
  }
};
</script>
